import type { Maybe } from '../../../../../../utils/typings';
import { Datatype, isObjectsArrayField } from '../../../../datatype/Datatype';
import { EvaluationScope } from '../../../../evaluate/EvaluationScope';
import { IReferenceObjectValue } from '../../../../references/IReference';
import { createConditionOperator } from '../../IConditionOperator';

export const ConditionOperatorAtleastOneType = createConditionOperator({
  code: 'atleastOne',
  label: 'almeno uno',
  description: 'Contiene almeno un elemento che',
  args: [{ type: 'arrayMatching' }],
  // È necessario che il campo sia un array di oggetti, è l'unica situazione
  // in cui è possibile utilizzare `arrayMatching`
  allowsField: field =>
    field.type === Datatype.Array && isObjectsArrayField(field),
  compare(
    value: any,
    [matching]: readonly [Maybe<IReferenceObjectValue[]>],
    scope: EvaluationScope,
  ) {
    if (!Array.isArray(value) || !matching) {
      return false;
    }

    // L'array matching contiene già il risultato della SubconditionsGroup,
    // nello specifico l'insieme di elementi che _verificano_ la condizione
    return matching.length > 0;
  },
});
